<app-common-subproducts-hero
  [heroData]="heroHeader"
></app-common-subproducts-hero>
<app-common-subproducts-alternate-blocks
  [featureData]="featureData1"
  [isInside]="true"
></app-common-subproducts-alternate-blocks>
<app-common-subproducts-customer-story
  [storyData]="storyData"
></app-common-subproducts-customer-story>
<app-common-subproducts-discover-difference
  [differenceData]="differenceData"
  isInside="true"
></app-common-subproducts-discover-difference>
<app-common-subproducts-pricing
  [pricingData]="pricingData"
></app-common-subproducts-pricing>
<app-common-subproducts-whitepaper
  [whitePaperData]="whitePaperData"
></app-common-subproducts-whitepaper>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
